import { useActivityMix } from '@features/design/hooks/activities.hooks';
import { List } from '@mui/material';
import {
  getEnergyClass,
  getMaxAllowedPrimaryEnergyValue,
} from '@shared/helpers/energy/energy-class';
import { sum } from '@shared/helpers/math.helpers';
import React from 'react';

import { NodonListItemResult } from '@ui/ListItemResult';
import { ConstantsGroup } from './Groups/Constants';
import { EnergyConsumptionGroup } from './Groups/EnergyConsumption';
import { HeatingDemandGroup } from './Groups/HeatingDemand';
import { PrimaryEnergyValueGroup } from './Groups/PrimaryEnergyValue';
import {
  useHasB6EnergyConsumption,
  useHeatedArea,
  usePrimaryEnergyValues,
} from '@features/energy/energy.hook';

export const EnergySection: React.FC = () => {
  const primaryEnergyValues = usePrimaryEnergyValues();
  const primaryEnergyValue = sum(primaryEnergyValues);
  const activityMix = useActivityMix();
  const maxAllowedPrimaryEnergyValue = getMaxAllowedPrimaryEnergyValue(
    useHeatedArea(),
    activityMix,
  );
  const energyClass = getEnergyClass(
    primaryEnergyValue,
    maxAllowedPrimaryEnergyValue,
  );
  const showEnergySection = useHasB6EnergyConsumption();

  return (
    <List dense>
      {/* Energy class */}
      <NodonListItemResult
        name="Energy class"
        tooltip="This is calculated based on the primary energy value and the allowed primary energy value accoding to Boverket. A means the building is very energy efficient (below 50% of the allowed primary energy value), G means the building is very energy inefficient (above 150% of the allowed primary energy value)."
        value={energyClass}
      />

      {showEnergySection && <EnergyConsumptionGroup />}

      <PrimaryEnergyValueGroup />

      <HeatingDemandGroup />

      {/* Allowed primary energy value */}
      <NodonListItemResult
        name="Allowed primary energy value"
        tooltip="The maximum allowed primary energy value for the building. This is calculated based on the heated area and the activity mix."
        value={maxAllowedPrimaryEnergyValue}
        unit="kWh/m^2"
      />

      <ConstantsGroup />
    </List>
  );
};
